import { SearchModes } from '@/domainLogic/index.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';

export type FacilityGroup = {
  id: string;
  name: FILTER_NAME;
  titleKey: string;
};

const facilityGroup = (id: string, name: FILTER_NAME): FacilityGroup => ({
  id,
  name,
  titleKey: `vacation.oss.filters.facilities.group.${id}`,
});

export const FACILITY_GROUPS: FacilityGroup[] = [
  facilityGroup('general', FILTER_NAME.FACILITIES_GENERAL_GROUP),
  facilityGroup('services', FILTER_NAME.FACILITIES_SERVICES),
  facilityGroup('food_drink', FILTER_NAME.FACILITIES_FOOD_DRINK),
  facilityGroup('pool_wellness', FILTER_NAME.FACILITIES_POOL_WELLNESS),
  facilityGroup('activities', FILTER_NAME.FACILITIES_ACTIVITIES),
  facilityGroup('outdoors', FILTER_NAME.FACILITIES_OUTDOORS),
  facilityGroup('internet', FILTER_NAME.FACILITIES_INTERNET),
  facilityGroup('parking', FILTER_NAME.FACILITIES_PARKING),
  facilityGroup('transport', FILTER_NAME.FACILITIES_TRANSPORT),
  facilityGroup('accessibility', FILTER_NAME.FACILITIES_ACCESSIBILITY),
  facilityGroup('health_safety', FILTER_NAME.FACILITIES_HEALTH_SAFETY),
  facilityGroup('safety_security', FILTER_NAME.FACILITIES_SAFETY_SECURITY),
  facilityGroup('kitchen', FILTER_NAME.FACILITIES_KITCHEN),
  facilityGroup('ski', FILTER_NAME.FACILITIES_SKI),
];

export const FACILITY_GROUP_FILTER_NAMES: FILTER_NAME[] = FACILITY_GROUPS.map((group) => group.name);

const DP_GROUP_ORDER = [
  'general',
  'pool_wellness',
  'food_drink',
  'internet',
  'services',
  'transport',
  'activities',
  'outdoors',
  'accessibility',
  'parking',
  'kitchen',
  'ski',
  'health_safety',
  'safety_security',
];

const HO_GROUP_ORDER = [
  'general',
  'food_drink',
  'internet',
  'pool_wellness',
  'parking',
  'services',
  'transport',
  'activities',
  'outdoors',
  'accessibility',
  'kitchen',
  'ski',
  'health_safety',
  'safety_security',
];

export const byFacilityGroupOrder = (searchMode: SearchModes) => {
  const order = searchMode === SearchModes.HO ? HO_GROUP_ORDER : DP_GROUP_ORDER;
  return (a: { id: string }, b: { id: string }) => order.indexOf(a.id) - order.indexOf(b.id);
};

export const ACCOMMODATION_FACILITY_FILTER_NAMES: FILTER_NAME[] = [
  FILTER_NAME.FACILITIES_GENERAL,
  FILTER_NAME.FACILITIES_FAMILY,
  FILTER_NAME.FACILITIES_ACTIVITY,
  FILTER_NAME.FACILITIES_WELLNESS,
  FILTER_NAME.FACILITIES_FOOD,
];

export const FACILITY_GROUP_DEFINITIONS: Partial<Record<FILTER_NAME, { urlParam: URLParameters }>> = Object.fromEntries(
  FACILITY_GROUP_FILTER_NAMES.map((name) => [name, { urlParam: URLParameters.FACILITIES }])
);
